import { MARQUEE_ITEMS } from "../lib/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS];
  return (
    <div className="bg-navy-deep border-y border-navy-light overflow-hidden py-3.5" data-testid="marquee" aria-label="Services and formats">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center shrink-0">
                <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-white/60 px-8 whitespace-nowrap">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-aqua shrink-0" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
